module.exports = __webpack_public_path__ + "img/carousel-04-md.7cf06666.png";